import React, { Component } from 'react';
import PropTypes from 'prop-types';

import InputItem from '../../../../components/form/inputitem';
import SelectItem from '../../../../components/form/selectitem';
import TextareaItem from '../../../../components/form/textareaitem';
import ListTag from '../../../../components/listtag';
import ModalFooter from '../../../../components/modalfooter';

class EntityForm extends Component {
    render() {
        const { hide_entity_name, entity_name_title, entity_name_placeholder, entity_name, onChangeEntityName, hide_entity_type, entity_type_title, entity_type_placeholder, entity_type, entity_type_options, onChangeEntityType, entity_child_container_class, hide_entity_child, entity_child_title, entity_title_class, entity_child_placeholder, entity_children, addNewChild, deleteChild, hide_description, description_title, description_placeholder, description, onChangeDescription, min_rows, max_rows, loading, button_cancel_text, button_ok_text, handleOkClick, handleCancelClick } = this.props;

        return (
            <div className="ori-pad-15">
                {
                    !hide_entity_name &&
                    <InputItem title={entity_name_title} placeholder={entity_name_placeholder} value={entity_name} onChange={onChangeEntityName} auto_focus />
                }
                {
                    !hide_entity_type &&
                    <SelectItem show_search title={entity_type_title} placeholder={entity_type_placeholder} value={entity_type} options={entity_type_options} onChange={onChangeEntityType} />
                }
                {
                    !hide_entity_child &&
                    <div className={entity_child_container_class}>
                        {
                            entity_child_title &&
                            <p className={`ori-b-mrgn-5 ori-capitalize-first ${entity_title_class}`}>{entity_child_title}</p>
                        }
                        <ListTag default_input container_class="ori-flex-row ori-flex-wrap ori-pad-5 ori-border-radius-4 ori-border-default" placeholder={entity_child_placeholder} list={entity_children} addNewTag={addNewChild} deleteTag={deleteChild} />
                    </div>
                }
                {
                    !hide_description &&
                    <TextareaItem title={description_title} placeholder={description_placeholder} min_rows={min_rows} max_rows={max_rows} value={description} onChange={onChangeDescription} />
                }
                <ModalFooter loading={loading} button_cancel_text={button_cancel_text} button_ok_text={button_ok_text} handleOkClick={handleOkClick} handleCancelClick={handleCancelClick} capsule_button />
            </div>
        );
    }
}

EntityForm.propTypes = {
    hide_entity_name: PropTypes.bool,
    entity_name_title: PropTypes.string,
    entity_name_placeholder: PropTypes.string,
    entity_name: PropTypes.string,
    onChangeEntityName: PropTypes.func,
    hide_entity_child: PropTypes.bool,
    entity_child_container_class: PropTypes.string,
    entity_child_title: PropTypes.string,
    entity_title_class: PropTypes.string,
    entity_child_placeholder: PropTypes.string,
    entity_children: PropTypes.array,
    addNewChild: PropTypes.func,
    deleteChild: PropTypes.func,
    hide_entity_type: PropTypes.bool,
    entity_type_title: PropTypes.string,
    entity_type_placeholder: PropTypes.string,
    entity_type: PropTypes.string,
    entity_type_options: PropTypes.array,
    onChangeEntityType: PropTypes.func,
    hide_description: PropTypes.bool,
    description_title: PropTypes.string,
    description_placeholder: PropTypes.string,
    min_rows: PropTypes.number,
    max_rows: PropTypes.number,
    description: PropTypes.string,
    onChangeDescription: PropTypes.func,
    loading: PropTypes.bool,
    button_ok_text: PropTypes.string,
    handleOkClick: PropTypes.func,
    button_cancel_text: PropTypes.string,
    handleCancelClick: PropTypes.func,
};

EntityForm.defaultProps = {
    hide_entity_name: false,
    entity_name_title: 'Entity Name',
    entity_name_placeholder: 'Enter entity name',
    hide_entity_type: false,
    entity_type_title: 'Entity Type',
    entity_type_placeholder: 'Enter entity type',
    hide_description: false,
    entity_child_container_class: "ori-tb-pad-5",
    entity_child_title: "entity children",
    entity_child_placeholder: "Add new child",
    description_title: 'description',
    description_placeholder: 'Write description about entity',
    min_rows: 3,
    max_rows: 5,
};

export default EntityForm;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/entityform/index.js